import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _3e9e2c0b = () => interopDefault(import('../pages/achievement/index.vue' /* webpackChunkName: "pages/achievement/index" */))
const _1dad1b43 = () => interopDefault(import('../pages/advertise/index.vue' /* webpackChunkName: "pages/advertise/index" */))
const _44688566 = () => interopDefault(import('../pages/agreement/index.vue' /* webpackChunkName: "pages/agreement/index" */))
const _e14c0010 = () => interopDefault(import('../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _a29186d0 = () => interopDefault(import('../pages/customer/index.vue' /* webpackChunkName: "pages/customer/index" */))
const _0b267bde = () => interopDefault(import('../pages/details/index.vue' /* webpackChunkName: "pages/details/index" */))
const _cf5617c8 = () => interopDefault(import('../pages/goals/index.vue' /* webpackChunkName: "pages/goals/index" */))
const _192c55f7 = () => interopDefault(import('../pages/maisoku/index.vue' /* webpackChunkName: "pages/maisoku/index" */))
const _1d2f2340 = () => interopDefault(import('../pages/media/index.vue' /* webpackChunkName: "pages/media/index" */))
const _7ca9f3e1 = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _0ca1f3f5 = () => interopDefault(import('../pages/project/index.vue' /* webpackChunkName: "pages/project/index" */))
const _e8561d8a = () => interopDefault(import('../pages/response/index.vue' /* webpackChunkName: "pages/response/index" */))
const _bed5957e = () => interopDefault(import('../pages/sale/index.vue' /* webpackChunkName: "pages/sale/index" */))
const _1f518d98 = () => interopDefault(import('../pages/achievement/output.vue' /* webpackChunkName: "pages/achievement/output" */))
const _8e54b3e0 = () => interopDefault(import('../pages/achievement/registration.vue' /* webpackChunkName: "pages/achievement/registration" */))
const _0acc780a = () => interopDefault(import('../pages/advertise/analysis.vue' /* webpackChunkName: "pages/advertise/analysis" */))
const _1227f822 = () => interopDefault(import('../pages/advertise/management.vue' /* webpackChunkName: "pages/advertise/management" */))
const _602da7d8 = () => interopDefault(import('../pages/advertise/registration.vue' /* webpackChunkName: "pages/advertise/registration" */))
const _19a604fa = () => interopDefault(import('../pages/calendar/registration.vue' /* webpackChunkName: "pages/calendar/registration" */))
const _171f663a = () => interopDefault(import('../pages/customer/registration.vue' /* webpackChunkName: "pages/customer/registration" */))
const _e5b4defc = () => interopDefault(import('../pages/goals/analysis.vue' /* webpackChunkName: "pages/goals/analysis" */))
const _82ff73cc = () => interopDefault(import('../pages/goals/setting.vue' /* webpackChunkName: "pages/goals/setting" */))
const _7ad00b4e = () => interopDefault(import('../pages/line/tracking/index.vue' /* webpackChunkName: "pages/line/tracking/index" */))
const _2223eb42 = () => interopDefault(import('../pages/maisoku/export.vue' /* webpackChunkName: "pages/maisoku/export" */))
const _2372b765 = () => interopDefault(import('../pages/maisoku/template.vue' /* webpackChunkName: "pages/maisoku/template" */))
const _049faae0 = () => interopDefault(import('../pages/response/registration.vue' /* webpackChunkName: "pages/response/registration" */))
const _0788a9bc = () => interopDefault(import('../pages/sale/output.vue' /* webpackChunkName: "pages/sale/output" */))
const _a3bd4240 = () => interopDefault(import('../pages/setting/announcement/index.vue' /* webpackChunkName: "pages/setting/announcement/index" */))
const _02366e3e = () => interopDefault(import('../pages/setting/import/index.vue' /* webpackChunkName: "pages/setting/import/index" */))
const _59ee2c6a = () => interopDefault(import('../pages/setting/mail-template.vue' /* webpackChunkName: "pages/setting/mail-template" */))
const _19f1babe = () => interopDefault(import('../pages/setting/matching-mail.vue' /* webpackChunkName: "pages/setting/matching-mail" */))
const _55135e4c = () => interopDefault(import('../pages/setting/shop.vue' /* webpackChunkName: "pages/setting/shop" */))
const _0583447d = () => interopDefault(import('../pages/setting/staff/index.vue' /* webpackChunkName: "pages/setting/staff/index" */))
const _105dcab5 = () => interopDefault(import('../pages/setting/step-mail/index.vue' /* webpackChunkName: "pages/setting/step-mail/index" */))
const _4307d937 = () => interopDefault(import('../pages/setting/tag/index.vue' /* webpackChunkName: "pages/setting/tag/index" */))
const _8f9f9366 = () => interopDefault(import('../pages/shop/document-template/index.vue' /* webpackChunkName: "pages/shop/document-template/index" */))
const _63aaf9b0 = () => interopDefault(import('../pages/shop/message/index.vue' /* webpackChunkName: "pages/shop/message/index" */))
const _2c95ffd6 = () => interopDefault(import('../pages/message/line/edit.vue' /* webpackChunkName: "pages/message/line/edit" */))
const _54b9c928 = () => interopDefault(import('../pages/message/line/log.vue' /* webpackChunkName: "pages/message/line/log" */))
const _5f9085c8 = () => interopDefault(import('../pages/message/line/registration/index.vue' /* webpackChunkName: "pages/message/line/registration/index" */))
const _708e7e70 = () => interopDefault(import('../pages/message/line/select.vue' /* webpackChunkName: "pages/message/line/select" */))
const _17737254 = () => interopDefault(import('../pages/message/line/send.vue' /* webpackChunkName: "pages/message/line/send" */))
const _0494a82a = () => interopDefault(import('../pages/message/mail/log.vue' /* webpackChunkName: "pages/message/mail/log" */))
const _1ca59fa2 = () => interopDefault(import('../pages/message/mail/registration.vue' /* webpackChunkName: "pages/message/mail/registration" */))
const _c01b79b6 = () => interopDefault(import('../pages/message/mail/select.vue' /* webpackChunkName: "pages/message/mail/select" */))
const _e418301e = () => interopDefault(import('../pages/message/mail/send.vue' /* webpackChunkName: "pages/message/mail/send" */))
const _6ddeecca = () => interopDefault(import('../pages/setting/announcement/registration.vue' /* webpackChunkName: "pages/setting/announcement/registration" */))
const _53bc4535 = () => interopDefault(import('../pages/setting/import/Detail.vue' /* webpackChunkName: "pages/setting/import/Detail" */))
const _0ca9d706 = () => interopDefault(import('../pages/setting/import/registration.vue' /* webpackChunkName: "pages/setting/import/registration" */))
const _bc04eed2 = () => interopDefault(import('../pages/setting/real-estate-agent/property-range.vue' /* webpackChunkName: "pages/setting/real-estate-agent/property-range" */))
const _9668ed44 = () => interopDefault(import('../pages/setting/staff/registration.vue' /* webpackChunkName: "pages/setting/staff/registration" */))
const _37701426 = () => interopDefault(import('../pages/setting/step-mail/registration.vue' /* webpackChunkName: "pages/setting/step-mail/registration" */))
const _60ce3cf9 = () => interopDefault(import('../pages/message/line/registration/success.vue' /* webpackChunkName: "pages/message/line/registration/success" */))
const _67c87f2a = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _31e8d19e = () => interopDefault(import('../pages/message/mail/edit/_id.vue' /* webpackChunkName: "pages/message/mail/edit/_id" */))
const _e892b0fa = () => interopDefault(import('../pages/agreement/log/_id.vue' /* webpackChunkName: "pages/agreement/log/_id" */))
const _58638900 = () => interopDefault(import('../pages/agreement/registration/_id.vue' /* webpackChunkName: "pages/agreement/registration/_id" */))
const _66537142 = () => interopDefault(import('../pages/customer/edit/_id.vue' /* webpackChunkName: "pages/customer/edit/_id" */))
const _62fa5166 = () => interopDefault(import('../pages/media/registration/_id.vue' /* webpackChunkName: "pages/media/registration/_id" */))
const _7f3f6d91 = () => interopDefault(import('../pages/project/registration/_id.vue' /* webpackChunkName: "pages/project/registration/_id" */))
const _07ee9a75 = () => interopDefault(import('../pages/response/add/_id.vue' /* webpackChunkName: "pages/response/add/_id" */))
const _26399948 = () => interopDefault(import('../pages/setting/announcement/_id.vue' /* webpackChunkName: "pages/setting/announcement/_id" */))
const _d5bb7bb6 = () => interopDefault(import('../pages/setting/staff/_id.vue' /* webpackChunkName: "pages/setting/staff/_id" */))
const _32d8f65d = () => interopDefault(import('../pages/setting/step-mail/_id.vue' /* webpackChunkName: "pages/setting/step-mail/_id" */))
const _9561a0e0 = () => interopDefault(import('../pages/shop/message/_id.vue' /* webpackChunkName: "pages/shop/message/_id" */))
const _a964959a = () => interopDefault(import('../pages/achievement/_id.vue' /* webpackChunkName: "pages/achievement/_id" */))
const _79f6ad64 = () => interopDefault(import('../pages/agreement/_id.vue' /* webpackChunkName: "pages/agreement/_id" */))
const _7c1bee74 = () => interopDefault(import('../pages/client-history/_id.vue' /* webpackChunkName: "pages/client-history/_id" */))
const _10c8f600 = () => interopDefault(import('../pages/customer/_id.vue' /* webpackChunkName: "pages/customer/_id" */))
const _64acf5a8 = () => interopDefault(import('../pages/media/_id.vue' /* webpackChunkName: "pages/media/_id" */))
const _aed320c6 = () => interopDefault(import('../pages/project/_id.vue' /* webpackChunkName: "pages/project/_id" */))
const _f455069e = () => interopDefault(import('../pages/property/_property.vue' /* webpackChunkName: "pages/property/_property" */))
const _0f449145 = () => interopDefault(import('../pages/property/_property/contact/index.vue' /* webpackChunkName: "pages/property/_property/contact/index" */))
const _53cd5d73 = () => interopDefault(import('../pages/property/_property/contact/confirm.vue' /* webpackChunkName: "pages/property/_property/contact/confirm" */))
const _230b47e5 = () => interopDefault(import('../pages/property/_property/contact/send.vue' /* webpackChunkName: "pages/property/_property/contact/send" */))
const _40d40663 = () => interopDefault(import('../pages/response/_id.vue' /* webpackChunkName: "pages/response/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/achievement",
    component: _3e9e2c0b,
    name: "achievement"
  }, {
    path: "/advertise",
    component: _1dad1b43,
    name: "advertise"
  }, {
    path: "/agreement",
    component: _44688566,
    name: "agreement"
  }, {
    path: "/calendar",
    component: _e14c0010,
    name: "calendar"
  }, {
    path: "/customer",
    component: _a29186d0,
    name: "customer"
  }, {
    path: "/details",
    component: _0b267bde,
    name: "details"
  }, {
    path: "/goals",
    component: _cf5617c8,
    name: "goals"
  }, {
    path: "/maisoku",
    component: _192c55f7,
    name: "maisoku"
  }, {
    path: "/media",
    component: _1d2f2340,
    name: "media"
  }, {
    path: "/privacy",
    component: _7ca9f3e1,
    name: "privacy"
  }, {
    path: "/project",
    component: _0ca1f3f5,
    name: "project"
  }, {
    path: "/response",
    component: _e8561d8a,
    name: "response"
  }, {
    path: "/sale",
    component: _bed5957e,
    name: "sale"
  }, {
    path: "/achievement/output",
    component: _1f518d98,
    name: "achievement-output"
  }, {
    path: "/achievement/registration",
    component: _8e54b3e0,
    name: "achievement-registration"
  }, {
    path: "/advertise/analysis",
    component: _0acc780a,
    name: "advertise-analysis"
  }, {
    path: "/advertise/management",
    component: _1227f822,
    name: "advertise-management"
  }, {
    path: "/advertise/registration",
    component: _602da7d8,
    name: "advertise-registration"
  }, {
    path: "/calendar/registration",
    component: _19a604fa,
    name: "calendar-registration"
  }, {
    path: "/customer/registration",
    component: _171f663a,
    name: "customer-registration"
  }, {
    path: "/goals/analysis",
    component: _e5b4defc,
    name: "goals-analysis"
  }, {
    path: "/goals/setting",
    component: _82ff73cc,
    name: "goals-setting"
  }, {
    path: "/line/tracking",
    component: _7ad00b4e,
    name: "line-tracking"
  }, {
    path: "/maisoku/export",
    component: _2223eb42,
    name: "maisoku-export"
  }, {
    path: "/maisoku/template",
    component: _2372b765,
    name: "maisoku-template"
  }, {
    path: "/response/registration",
    component: _049faae0,
    name: "response-registration"
  }, {
    path: "/sale/output",
    component: _0788a9bc,
    name: "sale-output"
  }, {
    path: "/setting/announcement",
    component: _a3bd4240,
    name: "setting-announcement"
  }, {
    path: "/setting/import",
    component: _02366e3e,
    name: "setting-import"
  }, {
    path: "/setting/mail-template",
    component: _59ee2c6a,
    name: "setting-mail-template"
  }, {
    path: "/setting/matching-mail",
    component: _19f1babe,
    name: "setting-matching-mail"
  }, {
    path: "/setting/shop",
    component: _55135e4c,
    name: "setting-shop"
  }, {
    path: "/setting/staff",
    component: _0583447d,
    name: "setting-staff"
  }, {
    path: "/setting/step-mail",
    component: _105dcab5,
    name: "setting-step-mail"
  }, {
    path: "/setting/tag",
    component: _4307d937,
    name: "setting-tag"
  }, {
    path: "/shop/document-template",
    component: _8f9f9366,
    name: "shop-document-template"
  }, {
    path: "/shop/message",
    component: _63aaf9b0,
    name: "shop-message"
  }, {
    path: "/message/line/edit",
    component: _2c95ffd6,
    name: "message-line-edit"
  }, {
    path: "/message/line/log",
    component: _54b9c928,
    name: "message-line-log"
  }, {
    path: "/message/line/registration",
    component: _5f9085c8,
    name: "message-line-registration"
  }, {
    path: "/message/line/select",
    component: _708e7e70,
    name: "message-line-select"
  }, {
    path: "/message/line/send",
    component: _17737254,
    name: "message-line-send"
  }, {
    path: "/message/mail/log",
    component: _0494a82a,
    name: "message-mail-log"
  }, {
    path: "/message/mail/registration",
    component: _1ca59fa2,
    name: "message-mail-registration"
  }, {
    path: "/message/mail/select",
    component: _c01b79b6,
    name: "message-mail-select"
  }, {
    path: "/message/mail/send",
    component: _e418301e,
    name: "message-mail-send"
  }, {
    path: "/setting/announcement/registration",
    component: _6ddeecca,
    name: "setting-announcement-registration"
  }, {
    path: "/setting/import/Detail",
    component: _53bc4535,
    name: "setting-import-Detail"
  }, {
    path: "/setting/import/registration",
    component: _0ca9d706,
    name: "setting-import-registration"
  }, {
    path: "/setting/real-estate-agent/property-range",
    component: _bc04eed2,
    name: "setting-real-estate-agent-property-range"
  }, {
    path: "/setting/staff/registration",
    component: _9668ed44,
    name: "setting-staff-registration"
  }, {
    path: "/setting/step-mail/registration",
    component: _37701426,
    name: "setting-step-mail-registration"
  }, {
    path: "/message/line/registration/success",
    component: _60ce3cf9,
    name: "message-line-registration-success"
  }, {
    path: "/",
    component: _67c87f2a,
    name: "index"
  }, {
    path: "/message/mail/edit/:id?",
    component: _31e8d19e,
    name: "message-mail-edit-id"
  }, {
    path: "/agreement/log/:id?",
    component: _e892b0fa,
    name: "agreement-log-id"
  }, {
    path: "/agreement/registration/:id?",
    component: _58638900,
    name: "agreement-registration-id"
  }, {
    path: "/customer/edit/:id?",
    component: _66537142,
    name: "customer-edit-id"
  }, {
    path: "/media/registration/:id?",
    component: _62fa5166,
    name: "media-registration-id"
  }, {
    path: "/project/registration/:id?",
    component: _7f3f6d91,
    name: "project-registration-id"
  }, {
    path: "/response/add/:id?",
    component: _07ee9a75,
    name: "response-add-id"
  }, {
    path: "/setting/announcement/:id",
    component: _26399948,
    name: "setting-announcement-id"
  }, {
    path: "/setting/staff/:id",
    component: _d5bb7bb6,
    name: "setting-staff-id"
  }, {
    path: "/setting/step-mail/:id?",
    component: _32d8f65d,
    name: "setting-step-mail-id"
  }, {
    path: "/shop/message/:id",
    component: _9561a0e0,
    name: "shop-message-id"
  }, {
    path: "/achievement/:id",
    component: _a964959a,
    name: "achievement-id"
  }, {
    path: "/agreement/:id",
    component: _79f6ad64,
    name: "agreement-id"
  }, {
    path: "/client-history/:id?",
    component: _7c1bee74,
    name: "client-history-id"
  }, {
    path: "/customer/:id",
    component: _10c8f600,
    name: "customer-id"
  }, {
    path: "/media/:id",
    component: _64acf5a8,
    name: "media-id"
  }, {
    path: "/project/:id",
    component: _aed320c6,
    name: "project-id"
  }, {
    path: "/property/:property?",
    component: _f455069e,
    name: "property-property",
    children: [{
      path: "contact",
      component: _0f449145,
      name: "property-property-contact"
    }, {
      path: "contact/confirm",
      component: _53cd5d73,
      name: "property-property-contact-confirm"
    }, {
      path: "contact/send",
      component: _230b47e5,
      name: "property-property-contact-send"
    }]
  }, {
    path: "/response/:id",
    component: _40d40663,
    name: "response-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
